import { render, staticRenderFns } from "./PrequalDisclaimers.vue?vue&type=template&id=cd26482c"
import script from "./PrequalDisclaimers.vue?vue&type=script&lang=ts"
export * from "./PrequalDisclaimers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports